// src/components/dashboard/departmentadmin/ParticipantTrendChart.js
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import DashboardCard from '../DashboardCard';

function ParticipantTrendChart({ data, loading }) {
  return (
    <DashboardCard
      title="Monthly Participant Trend"
      icon="bi-graph-up"
      loading={loading}
      isEmpty={!loading && data.length === 0}
      emptyMessage="No participant data yet."
    >
      <div style={{ width: '100%', height: 260 }}>
        <ResponsiveContainer>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Line type="monotone" dataKey="participants" stroke="#0d6efd" strokeWidth={2} name="Participants" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </DashboardCard>
  );
}

export default ParticipantTrendChart;
